import { createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { postCustomerDiscontinueIntakeSecure } from '../services/CustomerPublicV2Service';

export const useCustomerPublicV2PostCustomerDiscontinueIntakeSecure = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(postCustomerDiscontinueIntakeSecure, 'requestBody', 'data'),
      'data',
      'postalCode',
      'houseNumber',
      'houseNumberSuffix',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['postalCode', 'houseNumber', 'houseNumberSuffix'] },
    ],
  },
);
